<template>
  <div>
    <v-card :loading="loading" class="elevation-12">
      <template v-if="order">
        <v-card-actions>
          <v-spacer/>
          <OpenCreateReturnShipment v-if="allowCreateShipmentButton" :id="order.id"/>
          <CustomerApproveReturnOrder v-if="allowCustomerApproveButton" @approved="loadOrder" :id="order.id"/>
          <ExecutorApproveReturnOrder v-if="allowExecutorApproveButton" @approved="loadOrder" :id="order.id"/>
          <OpenEditReturnOrder v-if="allowEditButton" :id="order.id"/>
          <DeclineReturnOrder v-if="allowDeclineButton" @declined="loadOrder" :id="order.id"/>
          <CancelDeclineReturnOrder v-if="allowCancelDeclineButton" @canceled="loadOrder" :id="order.id"/>
          <ResumeReturnOrder v-if="allowResumeButton" @resumed="loadOrder" :id="order.id"/>
          <StopReturnOrder v-if="allowStopButton" @stopped="loadOrder" :id="order.id"/>
          <ReturnOrderProtocol :id="order.id" :order="order" className="ml-1" />
        </v-card-actions>

        <v-divider/>

        <v-card-text class="d-inline-flex">
          <span class="body-1 flex-grow-1">
            <b>Номер заказа</b>:
            <ReturnOrderStatus :status="order.status" :number="order.number" :id="order.id" :block="false" :text="true" :small="true" :follow-click="false"/>
            <br/>
            <b>Дата заказа на возврат: </b> {{ order.date | momentDate }}
            <br/>
            <b>Конечный срок возврата: </b> {{ order.expiresOn | momentDate }}
            <br>
            <b>Статус: </b> {{ getStatusText }}
          </span>
        </v-card-text>

        <v-card-text>
          <v-row>
            <v-col lg="6" cols="12">
              <h3>Заказчик</h3>
              <b>Наименование</b>: {{ order.customerName }}
              <br/>
              <b>Инн</b>: {{ order.customerInn }}
            </v-col>
            <v-col lg="6" cols="12">
              <h3>Поставщик</h3>
              <b>Наименование</b>: {{ order.executorName }}
              <br/>
              <b>Инн</b>: {{ order.executorInn }}
            </v-col>
          </v-row>

          <v-divider/>

          <v-row>
            <v-col lg="6" cols="12">
              <b>Номер договора</b>: {{ order.contractNumber }}
              <br/>
              <b>Дата договора</b>: {{ order.contractDate | momentDate }}
              <br/>
              <b>Конечный срок поставок</b>: {{ order.expiresOn | momentDate }}
              <br/>
              <b>Адрес отгрузки</b>: {{ order.deliveryAddress }}

              <template v-if="order.customerShipmentId">
                <br/>
                <b>Идентификатор поставки в системе заказчика</b>: {{ order.customerShipmentId }}
              </template>
            </v-col>
            <v-col lg="6" cols="12">
              <b>Редактирование заказа поставщиком: </b>:
              {{ order.executorEditStrategy.name }}
              <br/>
              <b>Метод определения даты поставки: </b>:
              {{ order.shipmentDeliveryDateStrategy.name }}
              <br/>
              <b>Время выставление счёт-фактуры по поставкам: </b>:
              {{ order.executorCreateInvoiceStrategy.name }}
              <br/>
              <b>Метод ограничения даты поставок: </b>:
              {{ order.shipmentDateMethodStrategy.name }}
              <br/>
              <b>Метод изменения названий товаров в накладных: </b>:
              {{ order.productNameDefineMethodStrategy.name }}
              <br/>
              <b>Метод определения договора: </b>:
              {{ order.contractDefineMethodStrategy.name }}
              <br/>
              <b>Метод ограничения позиций: </b>:
              {{ order.itemQuantityLimitStrategy.name }}
            </v-col>
          </v-row>

          <v-divider/>

          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center py-0 pa-1" style="width: 40px;">№</th>
                <th class="text-left py-0 pa-1">Товар</th>
                <th class="text-center py-0 pa-1" style="width: 115px;">ИД позиции поставки</th>
                <th class="text-center py-0 pa-1" style="width: 100px;">Штрих-код</th>
                <th class="text-center py-0 pa-1" style="width: 70px">ИКПУ-код</th>
                <th class="text-center py-0 pa-1" style="width: 40px;">Ед.изм</th>
                <th class="text-right py-0 pa-1" style="width: 120px;">Количество</th>
                <th class="text-right py-0 pa-1" style="width: 120px;">Цена за единицу</th>
                <th class="text-right py-0 pa-1" style="width: 125px;">Стоимость</th>
                <th class="text-center py-0 pa-1" style="width: 50px;">Ставка ндс</th>
                <th class="text-right py-0 pa-1" style="width: 125px;">Сумма ндс</th>
                <th class="text-right py-0 pa-1" style="width: 125px;">Стоимость с учётом НДС</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in order.items" :key="item.id">
                <td class="text-center py-0 pa-1">{{ index + 1 }}</td>
                <td>{{ item.product }}</td>
                <!--                <td class="text-center">{{ item.customerSystemId }}</td>-->
                <td class="text-center py-0 pa-1">{{ item.customerShipmentItemId }}</td>
                <td class="text-center py-0 pa-1">
                  <template v-if="item.customerCode">
                    {{ item.customerCode }}
                  </template>
                  <template v-else>
                    Нет
                  </template>
                </td>
                <td class="text-center py-0 pa-1">
                  <template v-if="item.catalogCode">
                    <SelectCatalogCodeDialog v-model="item.catalogCode" :default-value="item.catalogCode" :full-height="true" :disabled="true"/>
                  </template>
                  <template v-else>
                    Нет
                  </template>
                </td>
                <td class="text-center py-0 pa-1">{{ item.measurement }}</td>
                <td class="text-right py-0 pa-1">
                  <template v-if="showQuantityLeft">
                    -{{ item.quantityLeft | decimalNoTrim }} /
                  </template>
                  -{{ item.quantity | decimalNoTrim }}
                </td>
                <td class="text-right py-0 pa-1">{{ item.price | decimalNoTrim }}</td>
                <td class="text-right py-0 pa-1">-{{ item.total | decimalNoTrim }}</td>
                <td class="text-right py-0 pa-1">{{ item.ndsRate | decimalNoTrim }}</td>
                <template v-if="item.ndsValue === 0">
                  <td class="text-right py-0 pa-1">
                    {{ item.ndsValue | decimalNoTrim }}
                  </td>
                </template>
                <template v-else>
                  <td class="text-right py-0 pa-1">
                    -{{ item.ndsValue | decimalNoTrim }}
                  </td>
                </template>
                <td class="text-right py-0 pa-1">
                  -{{ item.totalWithNds | decimalNoTrim }}
                </td>
              </tr>
              <tr class="blue-grey lighten-4">
                <td></td>
                <td class="text-left py-0 pa-1"><b>Итого</b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right py-0 pa-1">-{{ totals.total | decimalNoTrim }}</td>
                <td class="text-right"></td>
                <td class="text-right py-0 pa-1"> -{{ totals.ndsValue | decimalNoTrim }}</td>
                <td class="text-right py-0 pa-1"> -{{ totals.totalWithNds | decimalNoTrim }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </template>
    </v-card>

    <ReturnShipmentDataTable ref="shipmentDataTable" v-if="order" class="my-3" :loading="loading"
                             :hideBranch="true"
                             :shipments="shipments"
                             :shipments-total="shipmentsTotalCount"
                             :show-branch-filter="false"
                             :start-default-value="defaultValue.start"
                             :end-default-value="defaultValue.end"
                             :is-executor-approved-default-value="defaultValue.isExecutorApproved"
                             :is-customer-approved-default-value="defaultValue.isCustomerApproved"
                             :is-decline-default-value="defaultValue.isDeclined"
                             :search-default-value="defaultValue.search"
                             :page-default-value="defaultValue.page"
                             :limit-default-value="defaultValue.limit"
                             :sort-default-value="defaultValue.sort"
                             :desc-default-value="defaultValue.desc"
                             :has-invoice-default-value="defaultValue.hasInvoice"
                             :status-default-value="defaultValue.status"
                             @update="onUpdate"
                             @print="onPrint"
                             @excel-single="onExcelSingleDownload"
                             @excel-all="onExcelAllDownload">
      <template v-slot:title>
        <v-card-title>Накладные заказа</v-card-title>
      </template>
    </ReturnShipmentDataTable>
  </div>
</template>
<script>
import _ from "underscore";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ReturnOrderService from "@/services/return.order.service";
import Mapper from "@/helpers/mappers";
import Moment from "moment";
import {SumLimit} from "@/enum/OrderItemQuantityLimitStrategyType";
import {AwaitCustomerApprove, AwaitExecutorApprove, ExecutorApproved, ExecutorDeclined, ExecutorEdited, GetStatusText, InProgress, Stopped} from "@/enum/OrderStatus";
import * as OrderExecutorEditStrategyTypes from "@/enum/OrderExecutorEditStrategyType";
import ReturnOrderStatus from "@/components/Status/ReturnOrderStatus";
import ReturnShipmentBoxMixin from "@/views/main/return-shipment/box/ReturnShipmentBoxMixin";
import ReturnShipmentDataTable from "@/components/DataTables/ReturnShipmentDataTable";
import OpenCreateReturnShipment from "@/components/Actions/ReturnOrder/OpenCreateReturnShipment";
import CustomerApproveReturnOrder from "@/components/Actions/ReturnOrder/CustomerApproveReturnOrder";
import ExecutorApproveReturnOrder from "@/components/Actions/ReturnOrder/ExecutorApproveReturnOrder";
import OpenEditReturnOrder from "@/components/Actions/ReturnOrder/OpenEditReturnOrder";
import DeclineReturnOrder from "@/components/Actions/ReturnOrder/DeclineReturnOrder";
import CancelDeclineReturnOrder from "@/components/Actions/ReturnOrder/CancelDeclineReturnOrder";
import StopReturnOrder from "@/components/Actions/ReturnOrder/StopReturnOrder";
import ResumeReturnOrder from "@/components/Actions/ReturnOrder/ResumeReturnOrder";
import ReturnOrderProtocol from "@/components/Actions/ReturnOrder/ReturnOrderProtocol";
import itemCalculator from "@/helpers/item.calculator"

export default {
  name: "ReturnOrderView",
  mixins: [ReturnShipmentBoxMixin],
  components: {
    ReturnOrderProtocol,
    ResumeReturnOrder,
    StopReturnOrder,
    CancelDeclineReturnOrder,
    DeclineReturnOrder,
    OpenEditReturnOrder,
    ExecutorApproveReturnOrder,
    CustomerApproveReturnOrder,
    OpenCreateReturnShipment,
    ReturnShipmentDataTable,
    ReturnOrderStatus
  },
  data() {
    return {
      order: null,
      loading: false,

      showQuantityLeft: false,
      getStatusText: '',
      allowCustomerApproveButton: false,
      allowExecutorApproveButton: false,
      allowEditButton: false,
      allowDeclineButton: false,
      allowCancelDeclineButton: false,
      allowStopButton: false,
      allowResumeButton: false,
      allowCreateShipmentButton: false,
    }
  },
  computed: {
    totals() {
      let total = 0
      let ndsValue = 0
      let totalWithNds = 0

      if (this.order) {
        _.each(this.order.items, (item) => {
          total += (+item.total)
          ndsValue += (+item.ndsValue)
          totalWithNds += +(item.totalWithNds)
        })
      }
      total = itemCalculator.getDecimalWithTwoDigit(total)
      ndsValue = itemCalculator.getDecimalWithTwoDigit(ndsValue)
      totalWithNds = itemCalculator.getDecimalWithTwoDigit(totalWithNds)

      return {total, ndsValue, totalWithNds}
    },
  },
  methods: {
    loadOrder() {
      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)
      ReturnOrderService.getInfo(this.$route.params.id)
          .then((response) => {
            this.order = Mapper.mapReturnOrderInfo(response.data)
            this.onOrderLoaded()
          })
          .catch(() => {
            this.$router.go(-1)
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    onOrderLoaded() {
      this.filters = {order: this.order.id}
      const nowMoment = Moment();

      this.showQuantityLeft = this.order.itemQuantityLimitStrategy === SumLimit
      this.getStatusText = GetStatusText(this.order.status)
      this.allowCustomerApproveButton = this.order.customerInn === this.$store.getters.companyInn && (this.order.status === AwaitCustomerApprove || this.order.status === ExecutorEdited)
      this.allowExecutorApproveButton = this.order.executorInn === this.$store.getters.companyInn && this.order.status === AwaitExecutorApprove
      this.allowDeclineButton = this.order.executorInn === this.$store.getters.companyInn && this.order.status === AwaitExecutorApprove
      this.allowCancelDeclineButton = this.order.executorInn === this.$store.getters.companyInn && this.order.status === ExecutorDeclined && this.order.executorDeclinedOn.isSame(nowMoment, 'date')
      this.allowStopButton = false//this.order.executorInn === this.$store.getters.companyInn && (this.order.status === ExecutorApproved || this.order.status === InProgress)
      this.allowResumeButton = this.order.executorInn === this.$store.getters.companyInn && this.order.status === Stopped
      this.allowEditButton = (
          (this.order.customerInn === this.$store.getters.companyInn && (this.order.status === AwaitCustomerApprove || this.order.status === ExecutorEdited)) ||
          (
              this.order.executorInn === this.$store.getters.companyInn &&
              this.order.status === AwaitExecutorApprove &&
              (
                  this.order.executorEditStrategy === OrderExecutorEditStrategyTypes.All ||
                  this.order.executorEditStrategy === OrderExecutorEditStrategyTypes.ItemQuantityToLowerValueOnly
              )
          )
      )
      this.allowCreateShipmentButton = this.order.customerInn === this.$store.getters.companyInn &&
          (
              this.order.status === ExecutorApproved ||
              this.order.status === InProgress
          ) &&
          (
              // order not sum limit type
              (this.order.itemQuantityLimitStrategy !== SumLimit) ||

              // or has any item which isn't completed
              (this.order.items.filter(item => {
                return item.quantityLeft > 0
              }).length > 0)
          )
    },
  },
  mounted() {
    this.loadOrder()
  },
  watch: {
    "$route.params.id"() {
      this.loadOrder()
    },
  }
}
</script>

<style scoped>
.status {
  min-width: 150px;
}
</style>